import React from 'react';
import { MemberState } from '../../../../../types/zinantis/members/membersType';
import MemberCard from './MemberCard';

interface MemberSegmentProps {
    segment: string;
    members: MemberState[];
    visibleSegmentName: boolean;
    visibleNewMember?: boolean;
}

const MemberSegment = (props: MemberSegmentProps) => {
    const {
        segment,
        members,
        visibleSegmentName,
        visibleNewMember = false,
    } = props;
    return (
        <div className='flex-column gap-10'>
            <h5 style={{ margin: 0 }}>{segment}</h5>
            <div className='flex gap-20 flex-wrap'>
                {members.map((member: MemberState) => {
                    return (
                        <MemberCard
                            key={member.id}
                            member={member}
                            visibleSegmentName={visibleSegmentName}
                            visibleNewMember={visibleNewMember}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default MemberSegment;
